import {
    Component,
    input,
    output,
} from '@angular/core';

import {
    FormsModule,
} from '@angular/forms';

import {
    ButtonModule,
} from 'primeng/button';

import {
    DialogModule,
} from 'primeng/dialog';

import {
    InputTextModule,
} from 'primeng/inputtext';


@Component({
    selector: 'pb-change-password-dialog',
    standalone: true,

    imports: [
        FormsModule,
        DialogModule,
        ButtonModule,
        InputTextModule,
    ],

    templateUrl:
        './change-password-dialog.component.html',

    styleUrls: [
        './change-password-dialog.component.scss',
    ],
})
export class ChangePasswordDialogComponent {

    visible = input(false);

    visibleChange = output<boolean>();

    changeRequested = output<string>();


    password = '';

    passwordConfirm = '';


    close(): void {

        this.visibleChange.emit(false);

        this.reset();
    }


    changePassword(): void {

        if (!this.isValid()) {
            return;
        }

        this.changeRequested.emit(
            this.password,
        );
    }


    isValid(): boolean {

        return (
            this.password.length >= 8 &&
            this.password === this.passwordConfirm
        );
    }


    hasMismatch(): boolean {

        return (
            this.passwordConfirm.length > 0 &&
            this.password !==
            this.passwordConfirm
        );
    }


    reset(): void {

        this.password = '';

        this.passwordConfirm = '';
    }
}